import React from "react";
import { reduxForm, Field } from "redux-form";
import { Col } from "react-bootstrap";
import { get } from "lodash";
import { update } from "MODULES/RMAsAndWarranties/actions";
import {
  Form as AppForm,
  Check,
  CheckGroup,
  FormRow,
  NumberInput,
  CurrencyField
} from "MODULES/shared/components/Forms";
import { withFieldsFromForm } from "MODULES/shared/decorators";
import {
  COST_ADJUSTMENT,
  CREDIT_DENIED,
  CREDIT_ISSUED,
  CREDIT_REQUESTED,
  CUSTOMER_RMA_CREDIT_AMOUNT,
  CUSTOMER_RMA_TYPE,
  PARTIAL_CREDIT_AMT,
  PARTIAL_CREDIT_REQUESTED
} from "MODULES/RMAsAndWarranties/constants";
import { properCase } from "LIB/formatters/text";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import validate from "./validate";

export function Form(props) {
  const { credit_issued: creditIssued, credit_denied: creditDenied } = props;
  const type = get(props, "rma.type");

  const fieldAmount = () => {
    const lineItem = get(props, "rma.sales_item");

    if (props.getFieldValue(PARTIAL_CREDIT_REQUESTED)) {
      return props.getFieldValue(PARTIAL_CREDIT_AMT);
    }

    if (lineItem.exchange_sale) {
      return lineItem.exchange_fee;
    }
    return (
      lineItem.quantity * lineItem.cost_per_unit +
      Number(get(props, "rma.cost_adjustments_after_sale"))
    );
  };

  const setToFullVal = val => {
    if (type === CUSTOMER_RMA_TYPE) {
      props.setFieldValue(CUSTOMER_RMA_CREDIT_AMOUNT)(
        val ? fieldAmount() : null
      );
    }
  };

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={3}>
            <CheckGroup title="Full Credit Requested?" justified>
              <Field
                name={CREDIT_REQUESTED}
                disabled={
                  props.getFieldValue(PARTIAL_CREDIT_REQUESTED) ||
                  get(props, "rma.credit_issued") ||
                  creditDenied
                }
                component={Check}
                label="Yes"
                icon="fa-check-circle"
              />
            </CheckGroup>
          </Col>
          {props.getFieldValue(CREDIT_REQUESTED) && [
            <Col md={3}>
              <CheckGroup title="Full Credit Issued?" justified>
                <Field
                  name={CREDIT_ISSUED}
                  component={Check}
                  label="Yes"
                  onChange={(_ev, val) => setToFullVal(val)}
                  icon="fa-check-circle"
                  disabled={get(props, "rma.credit_issued") || creditDenied}
                />
              </CheckGroup>
            </Col>,
            creditIssued && (
              <Col md={3}>
                <Field
                  name={CUSTOMER_RMA_CREDIT_AMOUNT}
                  component={NumberInput}
                  label={properCase(COST_ADJUSTMENT)}
                  disabled={get(props, "rma.credit_issued")}
                  required
                />
              </Col>
            ),
            <Col md={3}>
              <CheckGroup title="Full Credit Denied?" justified>
                <Field
                  name={CREDIT_DENIED}
                  component={Check}
                  label="Yes"
                  icon="fa-check-circle"
                  disabled={get(props, "rma.credit_denied") || creditIssued}
                />
              </CheckGroup>
            </Col>
          ]}
        </FormRow>
        <FormRow>
          <Col md={3}>
            <CheckGroup title="Partial Credit Requested?" justified>
              <Field
                name={PARTIAL_CREDIT_REQUESTED}
                disabled={
                  props.getFieldValue(CREDIT_REQUESTED) ||
                  get(props, "rma.credit_issued") ||
                  creditDenied
                }
                component={Check}
                label="Yes"
                icon="fa-check-circle"
              />
            </CheckGroup>
          </Col>
          {props.getFieldValue(PARTIAL_CREDIT_REQUESTED) && [
            <Col md={3}>
              <CheckGroup title="Partial Credit Issued?" justified>
                <Field
                  name={CREDIT_ISSUED}
                  component={Check}
                  label="Yes"
                  icon="fa-check-circle"
                  disabled={get(props, "rma.credit_issued") || creditDenied}
                />
              </CheckGroup>
            </Col>,
            <Col md={3}>
              <Field
                required
                name={PARTIAL_CREDIT_AMT}
                component={CurrencyField}
                label={properCase(PARTIAL_CREDIT_AMT)}
                disabled={!props.getFieldValue(PARTIAL_CREDIT_REQUESTED)}
              />
            </Col>,
            <Col md={3}>
              <CheckGroup title="Partial Credit Denied?" justified>
                <Field
                  name={CREDIT_DENIED}
                  component={Check}
                  label="Yes"
                  icon="fa-check-circle"
                  disabled={get(props, "rma.credit_denied") || creditIssued}
                />
              </CheckGroup>
            </Col>
          ]}
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

const formName = "rmaCredit";

export default reduxForm({
  form: formName,
  onSubmit: (values, dispatch) => dispatch(update(values)),
  validate
})(
  withFieldsFromForm(formName, [
    CREDIT_DENIED,
    CREDIT_ISSUED,
    PARTIAL_CREDIT_AMT
  ])(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/CustomerRmaCreditSection/Form.jsx